export default __webpack_public_path__ + "static/media/award.d11546bf.svg";